// Uses.js
import React from 'react';
// import { Link } from 'react-router-dom';
import './Uses.css'; // Import CSS for styling

function Uses() {
  return (
    <div className="uses-container">
      <header className="uses-header">
        <h2>Uses</h2>
      </header>

      <div className="tiles">
        <div className="tile">
          <h3>3D Printing</h3>
          <img src='3dprint.png' alt="3D Printing" />
          <ul>
            <li>Resin Printing</li>
            <li>FDM Printing</li>
            <li>Halot Mage 8k</li>
            <li>Creality CR10</li>
            <li>Monoprice Delta Mini</li>
            <li>Monoprice Select Mini II</li>
          </ul>
        </div>

        <div className="tile">
          <h3>CNC</h3>
          <img src="cnc.jpeg" alt="CNC" />
          <p>Shapeoko</p>
        </div>

        <div className="tile">
          <h3>Laser Etching</h3>
          <img src="laser.jpeg" alt="Laser Etching" />
          <p>M1 Carve</p>
          <p>Monoprice Select Mini II Laser Mod</p>
        </div>

        <div className="tile">
          <h3>Music</h3>
          <img src="music.png" alt="Music" />
          <ul>
            <li>Guitar - Fender Squire</li>
            <li>Guitar Pedals</li>
            <li>Trumpet</li>
            <li>Synths and Sequencers</li>
            {/* <li>Soundcloud</li> */}
            {/* <li></li> */}
          </ul>
        </div>

        <div className="tile">
          <h3>Photography & Videography</h3>
          <img src="photosky.png" alt="Came" />
          <ul>
            <li>Youtube Links</li>
            <li>Landscapes</li>
            <li>Hikes</li>
            <li>Sky & Astronomical</li>
          </ul>
        </div>

        <div className="tile">
          <h3>Microcontrollers</h3>
          <img src="attiny85pbc.png" alt="Microcontrollers" />
          <ul>
            <li>Arduino - Portenta H7, Uno, Leonardo</li>
            <li>ATtiny85</li>
            <li>Raspberry Pico</li>
            <li>Raspberry Pi - 3, 4, 5</li>
          </ul>
        </div>

        <div className="tile">
          <h3>Operating Systems</h3>
          <img src="operatingsystem.png" alt="Operating Systems" />
          <ul>
            <li>Apple iOS</li>
            <li>Android</li>
            <li>Windows</li>
            <li>Linux - Fedora, Mint</li>
          </ul>
        </div>

        <div className="tile">
          <h3>Certificates and Licenses</h3>
          <img src="certificates.png" alt="Certificates and Licenses" />
          <ul>
            <li>Details about certificates and licenses</li>
          </ul>
        </div>

        <div className="tile">
          <h3>Freelance Work</h3>
          {/* <img src="placeholder.png" alt="Freelance Work" /> */}
          <p>Mladen offers freelance work in various fields. </p>
          <p>Favorable rates and speedy delivery! </p>
          <a href='m'></a>
          <p><a href="mailto:hire@mladenmilesic.com">Hire Mladen!</a></p>
          {/* <Link to="/contact" className="App-link">Hire Me</Link> */}
        </div>

        {/* <div className="tile">
          <h3>Yo!</h3>
          <img src="placeholder.png" alt="Yo!" />
          <ul>
            <li>Netsfere</li>
            <li>Rinda</li>
            <li>Continental</li>
            <li>TCG</li>
            <li>Parata</li>
            <li>Coyote</li>
            <li>Mozaic</li>
          </ul>
        </div> */}

        <div className="tile">
          <h3>Open Source</h3>
          <img src="placeholder.png" alt="Open Source" />
          <ul>
            <li>Easy Servo</li>
            <li>Easy LED (pending)</li>
          </ul>
        </div>

        <div className="tile">
          <h3>Donate</h3>
          <img src="placeholder.png" alt="Donate" />
          <p>If youd like to support my work, consider donating! <a className="button" href="#donate">Buy me some coffee!</a></p>
          {/* <p>BTC</p>
          <p>ETH</p>
          <p>USD</p>
          <p>patreon</p>
          <p>only fans</p>
          <p>fan pass</p> */}
        </div>
      </div>

    </div>
  );
}

export default Uses;
